import $ from 'jquery';

// Media query listener helpers

function mqlRemoveListener(mql, handler) {
   return function() {
      mql.removeListener(handler);
   };
};

function mqlGetHandler(mql, success, fail) {
   return function (mql) {
      if (mql.matches && success) {
         success();
      }
      if (!mql.matches && fail) {
         fail();
      }
   };
};

export function addMediaQueryListener(query, success, fail, runOnce) {
    var mql = window.matchMedia(query),
        handler = mqlGetHandler(mql, success, fail);
    mql.addListener(handler);
    if (runOnce) handler(mql);
    return mqlRemoveListener(mql, handler);
};

// Stylesheet helper

export function newStyleSheet(media) {
  var style = $('<style></style>');
  if (media) style.attr('media', media);
  $('head').append(style);
  return style[0].sheet;
}